import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import BreadCrum from "../pages/BreadCrum";
import { TablePage } from "../pages/TablePage";
// import Tickets from "../dummy-data.json";
import { useDispatch } from "react-redux";
import { fetchTickets } from "../TicketAction";
import { SearchBox } from "../pages/search";

export const TicketList = () => {
  const dispatch = useDispatch();

  const [str, setStr] = useState("");
  useEffect(() => {
    dispatch(fetchTickets());
  }, [str, dispatch]);

  return (
    <>
      <Row>
        <h3>Ticket Lists</h3>
        <BreadCrum Data={"Ticket Lists"} />
        <Col>
          <SearchBox />
        </Col>
        <hr />
      </Row>

      <Row>
        <Col>
          <TablePage />
        </Col>
      </Row>
    </>
  );
};
